import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import EirButton from '../eir-button/EirButton';
import { currentUser } from '../../services/CurrentUser'
import Constants from '../../Constants';

class CookieBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consentGiven: false
    };
  }

  async componentDidMount() {
    this.setState({ consentGiven: await currentUser.getAttribute(Constants.cacheKeys.cookieConsent) });
  }

  closeCookieBanner = () => {
    currentUser.setAttribute(Constants.cacheKeys.cookieConsent,'true');

    this.setState({ consentGiven: true });
  };

  render() {
    if (!this.state.consentGiven) {
      return (
        <Container fluid className="eir-cookie-banner fixed-bottom bg-secondary text-white p-4">
          <Container>
            <Row>
              <Col md="9 p-2">
                  eir uses cookies to improve the services we provide online. By browsing this website, you agree to our use of cookies. Please see our cookies policy for more information.
              </Col>
              <Col md="3 p-2 text-md-center">
                <EirButton outline={true} text="close" color="white" type="button" onClick={this.closeCookieBanner} />
              </Col>
            </Row>
          </Container>
        </Container>
      );
    }
    return <div />;
  }
}

export default CookieBanner;
